import { AsyncPipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormInputAutofocusDirective, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import { DividerComponent, LoaderComponent, NotificationModule, PageComponent } from '@ftr/foundation'
import { PasswordComponent } from '@ftr/ui-password'
import { SingleSignOnModule } from '@ftr/ui-user'
import { AppLoaderComponent } from '~app/core/app-loader/app-loader.component'
import { LoginFormComponent } from './login-form/login-form.component'
import { LoginComponent } from './login/login.component'
import { LogoutComponent } from './logout/logout.component'

@NgModule({
  imports: [
    RouterModule,
    SingleSignOnModule,
    DividerComponent,
    PageComponent,
    LoaderComponent,
    NotificationModule,
    AppLoaderComponent,
    PasswordComponent,
    UntypedFormComponent,
    FormInputComponent,
    FormInputAutofocusDirective,
    AsyncPipe,
  ],
  declarations: [LoginComponent, LoginFormComponent, LogoutComponent],
  exports: [LoginComponent, LogoutComponent],
})
export class LoginModule {}
